<table>
  <thead>
    <tr>
      @for (column of columnNames | async; track column) {
        <th>{{ column }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (request of requests | async; track request) {
      <tr>
        <td>
          <a (click)="openDetail.emit(request[myEnv.Attributes.ObjectID])">
            {{ request?.[myEnv.Attributes.DisplayName] }}
          </a>
        </td>
        <td>{{ request?.[myEnv.Attributes.Operation] }}</td>
        <td>{{ request?.[myEnv.Attributes.CreatedTime] | localDate | async }}</td>
        <td>{{ request?.[myEnv.Attributes.RequestStatus] }}</td>
      </tr>
    }
    @if ((requests | async)?.length === 0) {
      <tr>
        <td colspan="4" class="text-center">
          <language key="EmptyList" defaultValue="No items."></language>
        </td>
      </tr>
    }
  </tbody>
</table>
